import { Container, Stack } from "@mui/material";
import { useMemo } from "react";
import useClientContext from "../../../contexts/useClientContext";
import useClientPageTitle from "../../../contexts/useClientPageTitle";
import NewsWidgetPreviewCard from "../../news/mobile/NewsWidgetPreviewCard";
import BalanceWidgetPreviewCard from "./BalanceWidgetPreviewCard";
import CashFlowsWidgetPreviewCard from "./CashFlowsWidgetPreviewCard";

const DashboardWidgetsMobilePage = () => {
  useClientPageTitle("Widgets");

  const { dashboardWidgets } = useClientContext();

  const { newsWidgetSettings, balanceWidgetSettings, cashFlowsWidgetSettings } = useMemo(
    () => ({
      newsWidgetSettings: dashboardWidgets.find((w) => w.predefinedType === "News"),
      balanceWidgetSettings: dashboardWidgets.find((w) => w.predefinedType === "Balance"),
      cashFlowsWidgetSettings: dashboardWidgets.find((w) => w.predefinedType === "CashFlows"),
    }),
    [dashboardWidgets]
  );

  return (
    <Container sx={{ flex: 1 }}>
      <Stack spacing={2} sx={{ py: 2 }}>
        {newsWidgetSettings && <NewsWidgetPreviewCard widgetSettings={newsWidgetSettings} />}
        {balanceWidgetSettings && <BalanceWidgetPreviewCard widgetSettings={balanceWidgetSettings} />}
        {cashFlowsWidgetSettings && <CashFlowsWidgetPreviewCard widgetSettings={cashFlowsWidgetSettings} />}
      </Stack>
    </Container>
  );
};

export default DashboardWidgetsMobilePage;
